"use client";

import { Box, Flex, Text } from "@chakra-ui/react";
import Link from "next/link";

import DefaultImage from "@/components/ui/DefaultImage";

const NotificationCard = ({ itemEl }) => {
  return (
    <Link href={itemEl?.url || "#"}>
      <Flex
        alignItems={"center"}
        columnGap={"12px"}
        p={"12px"}
        borderRadius={"4px"}
        bg={"white"}
        cursor={"pointer"}
      >
        <Box w={"40px"} h={"40px"} borderRadius={"4px"} overflow={"hidden"}>
          <DefaultImage
            src={
              itemEl?.logo
                ? process.env.NEXT_PUBLIC_IMAGES_URL + itemEl?.logo
                : "/images/no-company.svg"
            }
            options={{
              width: 40,
              height: 40,
              objectFit: "cover",
              alt: "notification icon",
            }}
          />
        </Box>
        <Flex flexDir={"column"} rowGap={"4px"}>
          <Text fontSize={"14px"} fontWeight={"700"} lineHeight={"1"}>
            {itemEl?.title}
          </Text>
          <Text fontSize={"12px"} fontWeight={"400"} lineHeight={"1"}>
            {itemEl?.description}
          </Text>
          <Text fontSize={"10px"} fontWeight={"700"} lineHeight={"1"}>
            {new Date(itemEl?.date).toLocaleDateString("en-eu", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </Text>
        </Flex>
      </Flex>
    </Link>
  );
};

export default NotificationCard;
